class EndPage {
    constructor(data) {
        this.content = data?.content || '';
        this.handouts = data?.handouts || [];
        this.showCrispChat = data?.showCrispChat ?? false;
    }
}

export default EndPage;
